import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorTokens.content.onDark};
  padding: ${({ theme }) => theme.space["space-4"]};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.space["space-3"]};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentContainer = styled.div`
  margin-top: ${({ theme }) => theme.space["space-3"]};
  display: flex;
`;

export const Grid = styled.div<{ numberOfCols: number; gap: string }>`
  display: grid;
  grid-template-columns: ${({ numberOfCols }) =>
    `repeat(${numberOfCols}, auto)`};
  grid-gap: ${({ gap }) => gap};
`;

export const Item = styled.div<{ isCol: boolean }>`
  display: flex;
  flex-direction: ${({ isCol }) => (isCol ? "column" : "row")};
  align-items: ${({ isCol }) => (isCol ? "flex-start" : "center")};
`;
